// extracted by mini-css-extract-plugin
export default {"language_dropdown":"LanguageSelector_language_dropdown__o3cGL","innerContainer":"LanguageSelector_innerContainer__2+-pj","heading":"LanguageSelector_heading__GRdb8"};